/* @flow */
import React from 'react';

const NotFound = () => (
  <div className="NotFound">
    <div className="container-fluid">
      <h1>Page Not Found</h1>
    </div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/NotFound/index.js